<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-tipo-permiso />
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Tipo Permisos
    </h3>
    <v-card>
      <!-- Boton filtro -->
      <!-- <v-tooltip bottom>
        <v-btn
          @click.native="
            () => {
              filterShow = filterShow ? false : true;
            }
          "
          class="btn-refresh"
          slot="activator"
          ><v-icon>filter_list</v-icon>
        </v-btn>
        <span>Búsqueda/filtros</span>
      </v-tooltip> -->

      <!-- Boton acutualizar -->
      <!-- <v-tooltip bottom>
        <v-btn
          @click.native="cargarTipoPermisos()"
          class="btn-refresh"
          slot="activator"
          ><v-icon>refresh</v-icon>
        </v-btn>
        <span>{{ $t("common.updateList") }}</span>
      </v-tooltip> -->
      <!-- Filtros-->
      <!-- <v-card color="#eeffff" v-if="filterShow">
        <v-card-text class="sinMargen">
          <v-container class="filtroSicobs" grid-list-md>
            <v-layout wrap>
              <v-flex xs11></v-flex>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  color="#D7F64F"
                  @click.native="recargar()"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
                <span>Recargar filtros</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="
                    () => {
                      filterShow = false;
                      recargar();
                    }
                  "
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <span>Cerrar filtros</span>
              </v-tooltip>
            </v-layout>
            <v-layout wrap>
              <v-flex xs2>
                <v-text-field
                  label="Tipo de permiso"
                  type="text"
                  v-model="form.descripcion"
                  @input="filterDescripcion(form.descripcion)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <br />
      </v-card>
      <br /> -->
      <v-card-text>
        <!-- <crud-table
					:headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
					:graphql="graphql"
				> 
      :search="filters"
     :custom-filter="customFilter"
      :search="filters"
          :custom-filter="customFilter"-->
        <v-data-table
          :headers="headers"
          :items="tipo_permisos"
          class="elevation-1 tabla-comprimida-light"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="index"
        
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <!-- <template slot="buttons">
            <v-tooltip bottom>
             <v-btn color="primary" dark
               @click.native.stop="crearActualizarTipoPermiso({})"
               slot="activator"
             ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
             <span>Agregar Tipo permiso</span>
           </v-tooltip>
          </template> -->

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.nombre }}</td> -->

            <!-- <template slot="items" slot-scope="items"> -->
            <!-- Agregar las columnas que consideré necesarias -->
            <!-- <td class="text-xs-center">{{ items.item.parametro_tipo_permiso.valor}}</td> -->
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
            <!-- <td class="text-xs-center">{{ $moment(items.item._created_at).format('L')}}</td> -->
            <td class="text-xs-center">
              {{ items.item.refrigerio === true ? "SI" : "NO" }}
            </td>
            <!-- <td class="text-xs-center">{{ items.item.tiempo_maximo }}</td>
            <td class="text-xs-center">{{ items.item.tiempo_minimo }}</td> -->
            <td class="text-xs-center">
              {{ items.item.estado ? items.item.estado.descripcion : "" }}
            </td>
            <td class="text-xs-center">{{ items.item.tolerancia }}</td>
            <!-- <td class="text-xs-center">{{ items.item.compensacion === true ? 'SI' : 'NO'}}</td> -->
            <!-- <td class="text-xs-center">{{ items.item.id_parametro_elaborado === 91 ? 'Servidor Publico' : 'Recursos Humanos'}}</td> -->

            <!-- </template> -->

            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  color="rgb(145,26,230)"
                  dark
                  slot="activator"
                  @click.native="crearActualizarTipoPermiso(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <!-- <v-tooltip bottom>
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'tipoPermiso')"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip> -->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarTipoPermiso from "./dialogs/CrearActualizarTipoPermiso"; // Componente de creación y actualización
import Filtros from "./mixins/filtros";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud,Filtros],
  // Variables iniciales del componente
  data() {
    return {
      url: "tipoPermisos",
      graphql: true,
      tipo_permisos: [],
      loading: false,
      form: {},
      // Variables filtros
      filters: {
        descripcion: "",
      },
      filterShow: true,
      // Cabecera de la tabla
      headers: [
        { text: "Tipo Permiso", value: "descripcion", align: "center" },
        // { text: 'Descripcion', value: 'descripcion', align: 'center' },
        // { text: 'Fecha Registro', value: '_created_at', align: 'center' },
        { text: "Refrigerio", value: "refrigerio", align: "center" },
        // { text: 'Tiempo maximo (Hrs.)', value: 'tiempo_maximo', align: 'center' },
        // { text: 'Tiempo minimo (Hrs.)', value: 'tiempo_minimo', align: 'center' },
        { text: "Estado", value: "estado", align: "center" },
        // { text: 'Compensacion', value: 'compensacion', align: 'center' },
        // { text: 'Elaborado', value: 'id_parametro_elaborado', align: 'center' },
        { text: "Tolerancia", value: "tolerancia", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        tipo
        descripcion
        refrigerio
        tiempo_maximo
        tiempo_minimo
        id_estado
        estado{
          id
          descripcion
        }
        id_parametro_tipo_permiso
        parametro_tipo_permiso{
          id
          valor
        }
        compensacion
        id_parametro_elaborado
        tolerancia
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [
        // {
        //     field: "descripcion",
        //     label: "descripcion",
        //     type: "text",
        //     typeG: "String",
        //   },
      ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarTipoPermisos();
    this.$bus.$on("closeDialog", async() => {
      await this.cargarTipoPermisos();
    });
    // this.onFilter();
  },
  // Métodos y funciones del componente
  methods: {
    crearActualizarTipoPermiso(item) {
      this.$bus.$emit("openDialogCrearActualizarTipoPermiso", item);
    },
    async cargarTipoPermisos() {
      this.loading = true;
      try {
        let respuesta = await this.$service
          .graphql({
            query: `
              query{
                tipoPermisos{
                  rows{
                    id
                   tipo
                   descripcion
                   refrigerio
                   tolerancia
                   plazo
                   estado{
                      id
                      descripcion
                    }
                    id_parametro_tipo_permiso
                    parametro_tipo_permiso{
                      id
                      valor
                    }
                  }
                }
              }
            `,
          })
          .then(async (response) => {
            if (response) {
              this.tipo_permisos = response.tipoPermisos.rows;
            }
          });

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value,
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $tipo_permiso: EditTipoPermiso!) {
              tipoPermisoEdit(id: $id, tipo_permiso: $tipo_permiso) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            tipo_permiso: data,
          },
        });
        if (value === 1) {
          this.$message.success("Tipo Permiso habilitado");
        } else {
          this.$message.warning("Tipo Permiso deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarTipoPermiso,
  },
};
</script>

<style>
.filtroSicobs {
  min-width: 100%;
  padding: 0em 0.5em 0em 0.5em;
}
.sinMargen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/tipo_permiso/Index.vue